import e from "./highrise1829.mjs";
function n(r, a) {
  var t = r.__data__;
  return e(a) ? t[typeof a == "string" ? "string" : "hash"] : t.map;
}
export {
  n as default
};
